// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kLuB","top":"styles_top__2BT8A"};